export default "__VITE_ASSET__9232b19c__"